<template>
  <div>

  
    <label v-if="label">{{ label }}</label>
    <div class="input-group mb-2">
    <div class="input-group-prepend">
      <div class="input-group-text euro">€</div>
    </div>   
      <input 
        :required="required"
        v-focus="autofocus"
        type="number"
        class="form-control"
        :value="displayValue"
        @input="onInput"
        :min="min"
        :max="max"
        step="0.01"
        :placeholder="placeholder"
      />
       <div v-if="btn" class="input-group-append">
            <div @click="add()" class="input-group-text sconto pointer">Inserisci sconto</div>
          </div>
    </div>
  

</div>  
</template>

<script>
export default {
  name: "InputPrezzo",
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      default: ""
    },
    min: {
      type: Number,
      default: 0.01
    },
    max: {
      type: Number
      
    },
    autofocus : {type : Boolean},
    placeholder: {
      type: String,
      default: "Inserisci prezzo"
    },btn :{ type : Boolean,default :false},
    required : {type :Boolean,default:true}

  }, 

  directives: {
    focus: {
      inserted(el, binding) {
        if (binding.value) {
          el.focus()
        }
      }
    }
  },
   
  computed: {
    displayValue() {
      // Gestione stringhe vuote
      return this.value === null || this.value === "" ? "" : Number(this.value);
    }
  },
  methods: {
    onInput(event) {
      let val = event.target.value;
      
      
      // Se è vuoto
      
      // val = Number(val);

      // Corregge valori fuori range
  //      if (isNaN(val) || val < this.min) val = this.min;
  //     if (val > this.max) val = this.max;

      // Emissione standard v-model
      this.$emit("input", val);

      // Log opzionale per capire quale input sta cambiando
      console.log(`InputPrezzo '${this.label}' aggiornato a:`, val);
    }
  }
};
</script>
<style scoped >
.euro
{
  color             : white ;
  background-color  :  darkgreen;;
}
label
{
  font-weight: bold;
}
</style>